import { Button } from '@material-ui/core';
import cx from 'classnames';
import { camelCase } from 'lodash';

import { IconNewLock } from 'src/assets/icons/NewLock';
import { useMenuOpenedState } from 'src/lib/hooks';

import { ITEM_TYPE } from '../../lib';
import { BrandVoiceContextMenu } from '../BrandVoiceContextMenu';
import { VisualLanguageContextMenu } from '../VisualLanguageContextMenu';

import { useStyles } from './useStyles';

export const SidebarButton = ({
  className,
  classes,
  item,
  active,
  onSubmenuItemClick,
  children,
  onClick,
  activeIcon,
  onSidebarAction,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  const { menuOpened, handleMenuOpen, handleMenuClose } = useMenuOpenedState();

  const StartIcon = (active && activeIcon) || item.icon;

  return (
    <div
      className={cx(styles.wrapper, {
        [styles.contextMenuOpened]: menuOpened,
      })}
    >
      <Button
        className={cx(styles.root, className, {
          [styles.active]: active,
          [styles.isEmptySubmenuItem]: Boolean(item.options?.emptySubmenuItem),
          [styles.whiteIcon]: Boolean(item.options?.whiteIcon),
        })}
        classes={{
          label: styles.label,
          startIcon: styles.startIcon,
          endIcon: styles.endIcon,
        }}
        style={item.style}
        onClick={onClick}
        startIcon={StartIcon ? <StartIcon className={styles.iconStart} /> : undefined}
        endIcon={item.locked ? <IconNewLock /> : item.endIcon && <item.endIcon />}
        data-testid={`SidebarLink_${camelCase(item.label)}`}
        {...restProps}
      >
        {children || item.label}
      </Button>

      {item.type === ITEM_TYPE.brandVoice && item.brandVoice && (
        <BrandVoiceContextMenu
          className={styles.collapseButtonActionMenu}
          brandVoice={item.brandVoice}
          onSidebarAction={onSidebarAction}
          dataTestId={`collapseMenuItem${item.brandVoice.id}`}
          onOpen={handleMenuOpen}
          onClose={handleMenuClose}
        />
      )}

      {item.type === ITEM_TYPE.visualLanguage && item.visualLanguage && (
        <VisualLanguageContextMenu
          className={styles.collapseButtonActionMenu}
          visualLanguage={item.visualLanguage}
          onSidebarAction={onSidebarAction}
          dataTestId={`collapseMenuItem${item.visualLanguage.id}`}
          onOpen={handleMenuOpen}
          onClose={handleMenuClose}
        />
      )}
    </div>
  );
};
